import React from 'react';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Icon from '../Icon';

export default () => (
  <>
    <Heading level={2}>Navigation Icons</Heading>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="dashboard" />
        <Spacer size={6} />
        <Code>{'dashboard'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="dashboard-filled" />
        <Spacer size={6} />
        <Code>{'dashboard-filled'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="performance" />
        <Spacer size={6} />
        <Code>{'performance'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="performance-filled" />
        <Spacer size={6} />
        <Code>{'performance-filled'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="team" />
        <Spacer size={6} />
        <Code>{'team'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="team-filled" />
        <Spacer size={6} />
        <Code>{'team-filled'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="clients" />
        <Spacer size={6} />
        <Code>{'clients'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="clients-filled" />
        <Spacer size={6} />
        <Code>{'clients-filled'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="arrow-right" />
        <Spacer size={6} />
        <Code>{'arrow-right'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="arrow-up" />
        <Spacer size={6} />
        <Code>{'arrow-up'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="arrow-down" />
        <Spacer size={6} />
        <Code>{'arrow-down'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="chevron-left" />
        <Spacer size={6} />
        <Code>{'chevron-left'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="chevron-right" />
        <Spacer size={6} />
        <Code>{'chevron-right'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="chevron-up" />
        <Spacer size={6} />
        <Code>{'chevron-up'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="chevron-down" />
        <Spacer size={6} />
        <Code>{'chevron-down'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" sizze={16} />
      <FlexView align="center">
        <Icon name="more" />
        <Spacer size={6} />
        <Code>{'more'}</Code>
        <Spacer size={16} />
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="menu" />
        <Spacer size={6} />
        <Code>{'menu'}</Code>
        <Spacer size={16} />
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="grid" />
        <Spacer size={6} />
        <Code>{'grid'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="close" />
        <Spacer size={6} />
        <Code>{'close'}</Code>
      </FlexView>
      <FlexView align="center" />
    </FlexView>
  </>
);
